<template>
    <div
        class="next"
        :class="extraClass">
        <button
            type="submit"
            :disabled="isDisabled"
            :class="{ active: !isDisabled }"
            @click.stop.prevent="$emit('click')">
             <slot></slot>
        </button>
    </div>
</template>

<script>
export default {
    name: 'NextButton',
    props: [
        'extraClass',
        'isDisabled'
    ]
}
</script>
